import URL2 from '../config.js';

export const getInitials = (string) =>
    (string || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .reduce((response, word) => response + word.slice(0, 1), '')
        .toUpperCase()
        .slice(0, 2)


export const checkCodeofConduct = async (ParentID) => {
    const { data } = await URL2.post(`/parent/check-code-of-conduct`, {
        ParentID: ParentID
    })
    if (data.codeOfConductSubmitted) {
        return true;
    }
    return false;
}

export const getAuthToken = () => {
    return localStorage.getItem('LoginToken');
}

export const queueConfirmationEmail = ({ SessionID, parent_email, family_name, college, parent_id }) => {
    return URL2.post('/sendEmail', {
        SessionID,
        parent_email,
        family_name,
        college,
        parent_id,
    });
}
